import { isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_ONPREMISE } from 'reactApp/appHelpers/configHelpers';

// Можно ли показывать кнопку "Скачать" на тамбе для паблик файлов. По дефолту можно в онпремис
export const showPublicFileDownloadButton = isFeature('public-file-dwnld-btn') || IS_ONPREMISE;
